import React from "react";
import { useNavigate } from "react-router-dom";
import { Box, Button, Card, CardActionArea, Grid, Typography } from "@mui/material";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

// Mosaico compartido por los hubs de Extensión. Existe porque el módulo pasó a
// tener dos niveles —Extensión → Aspirantes / Convenios → sus pantallas— y el
// mismo mosaico se pinta tres veces: tenerlo escrito una sola vez es lo que
// garantiza que los tres niveles se vean igual.
//
// Cada opción es { key, label, description, icon, path } o, cuando no navega a
// ninguna parte, { ..., onClick }.
export const HUB_ICON_SX = { fontSize: { xs: 44, md: 56 } };

export default function HubGrid({ title, subtitle, options, backTo, backLabel, children }) {
  const navigate = useNavigate();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "70vh",
        px: { xs: 2, md: 4 },
        py: 4,
      }}
    >
      {/* La vuelta al nivel de arriba sólo se ofrece cuando ese nivel tiene algo
          que mostrar: a quien sólo entra a una rama, el hub superior lo
          devolvería aquí mismo, y el botón sería una promesa falsa. */}
      {backTo && (
        <Box sx={{ width: "100%", maxWidth: 900, mb: 1 }}>
          <Button size="small" startIcon={<ArrowBackIcon />} onClick={() => navigate(backTo)}>
            {backLabel || "Volver"}
          </Button>
        </Box>
      )}

      <Typography variant="h4" gutterBottom>{title}</Typography>
      <Typography variant="body1" color="text.secondary" sx={{ mb: 4 }}>
        {subtitle}
      </Typography>

      <Grid container spacing={3} justifyContent="center" sx={{ width: "100%", maxWidth: 900 }}>
        {options.map((opt) => (
          <Grid item xs={12} sm={6} md={4} key={opt.key}>
            <Card
              sx={{
                height: "100%",
                transition: "box-shadow 0.2s ease, transform 0.2s ease",
                "&:hover": { boxShadow: 6, transform: "translateY(-4px)" },
              }}
            >
              <CardActionArea
                onClick={() => (opt.onClick ? opt.onClick() : navigate(opt.path))}
                sx={{ height: "100%" }}
              >
                <Box sx={{ display: "flex", flexDirection: "column", alignItems: "center", textAlign: "center", p: 3 }}>
                  <Box sx={{ color: "primary.main", mb: 1.5 }}>{opt.icon}</Box>
                  <Typography variant="h6" gutterBottom>{opt.label}</Typography>
                  <Typography variant="body2" color="text.secondary">{opt.description}</Typography>
                </Box>
              </CardActionArea>
            </Card>
          </Grid>
        ))}
      </Grid>

      {children}
    </Box>
  );
}

// Estado vacío común: el usuario llegó a un hub al que no tiene acceso.
export function HubNoAccess({ title, message }) {
  return (
    <Box sx={{ p: 4, textAlign: "center" }}>
      <Typography variant="h6" gutterBottom>{title}</Typography>
      <Typography variant="body2" color="text.secondary">{message}</Typography>
    </Box>
  );
}
